import { LeftMenuItem } from 'components/LeftMenu/LeftMenuItem';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import React from 'react';
import { Drawer, IconButton, Link, List, Toolbar } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { getText } from 'services/languageService';
import { setOpenFeedbackModalAction } from 'store/actions/feedback';
import { setOpenLoginAction } from 'store/actions/mainPage';
import { LeftMenuProps, MainLangType } from 'types/mainPage';

const getMainUrl = (lang: MainLangType) => {
  switch (lang) {
    case 'en':
      return '../eng.html';
    case 'by':
      return '../bel.html';
    case 'ru':
      return '/';
    default: {
      return '/';
    }
  }
};

export const LeftMenu: React.FC<LeftMenuProps> = ({ open, toggleDrawer }) => {
  const { lang } = useAppSelector((state) => state.mainPage);
  const dispatch = useAppDispatch();

  const openLogInModal = () => {
    dispatch(setOpenLoginAction(true));
  };

  return (
    <Drawer
      open={open}
      anchor="left"
      onClose={toggleDrawer}
      sx={{
        '& .MuiDrawer-paper': {
          backgroundColor: (theme) => theme.palette.custom.leftMenuBg,
          color: 'white',
          width: '100vw',
        },
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          px: [1],
        }}
      >
        <IconButton onClick={toggleDrawer} color={'inherit'}>
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>
      <List component="nav">
        <Link
          href={getMainUrl(lang)}
          sx={{
            display: 'block',
            pl: 2,
            mb: 1,
            textDecoration: 'none',
            color: 'white',

            '&:hover': {
              textDecoration: 'none',
            },
          }}
        >
          {getText('TO_MAIN')}
        </Link>
        <LeftMenuItem
          text={getText('FEEDBACK')}
          handleMenuItem={() => dispatch(setOpenFeedbackModalAction(true))}
        />
        <LeftMenuItem
          text={getText('LOG_IN')}
          handleMenuItem={openLogInModal}
        />
      </List>
    </Drawer>
  );
};
